import React from 'react';
import type { CompanyPrintInfo } from '@/components/sales-invoice/PrintableSalesInvoice';
import type { DeliveryPrintData } from '@/services/delivery.service';
import { EngineDeliveryNotePrint } from '@/components/print/EngineLetterheadPrints';

export type DeliveryPrintLetterheadVariant = 'preprinted' | 'letterhead';

/** Delivery note print — shared pagination engine (measure → plan → composed pages). */
export function DeliveryNotePrintView({
  data,
  companyInfo = { name: 'Company' },
  printVariant = 'letterhead',
  onClose,
}: {
  data: DeliveryPrintData;
  companyInfo?: CompanyPrintInfo;
  printVariant?: DeliveryPrintLetterheadVariant;
  onClose?: () => void;
}) {
  return (
    <EngineDeliveryNotePrint
      data={data}
      companyInfo={companyInfo}
      printVariant={printVariant}
      onClose={onClose}
    />
  );
}
